import { render, staticRenderFns } from "./LandlordAdditionalFileUpload.vue?vue&type=template&id=2d1921d5&scoped=true"
import script from "./LandlordAdditionalFileUpload.vue?vue&type=script&lang=js"
export * from "./LandlordAdditionalFileUpload.vue?vue&type=script&lang=js"
import style0 from "./LandlordAdditionalFileUpload.vue?vue&type=style&index=0&id=2d1921d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1921d5",
  null
  
)

export default component.exports